import VueTypes from 'vue-types';
import { VTSpot } from '@/mikan/_shared/types/vueTypes/spot';

export const VTStockId = VueTypes.string;
export const StockProps = {
  id: VTStockId.isRequired,
  date: VueTypes.string.isRequired,
  startTime: VueTypes.string.isRequired,
  endTime: VueTypes.string.isRequired,
  hasReservation: VueTypes.bool.isRequired,
  isAccepting: VueTypes.bool.isRequired,
  spot: VTSpot.isRequired,
};
export const VTStock = VueTypes.shape(StockProps);
